import { ObservableArray, View } from "binder"
import { MeasuredParameterGroup, MeasuredParameterGroupViewModel } from "./measuredParameterGroup-viewModel"
import { IPopup } from "src/common/userMainWindow/windowContainer/IPopup";

export class MeasuredParameterGroupView extends View<MeasuredParameterGroupViewModel>{
    GetViewUniqueId(): string {
        return "V-58BC4CFF-1F8C-496B-867A-26D60EBCBE64"
    }
    loadHtml(): string {
        let element = require('./measuredParameterGroup.html').default;
        let style = require('./measuredParameterGroup.less');
        return element;
    }
    constructor() {
       super();
    }

    public set isShowingPopup(v: boolean) { this._isShowingPopup = v; } public get isShowingPopup(): boolean { return this._isShowingPopup;} private _isShowingPopup: boolean;
    public set popup(v: IPopup) { this._popup = v; } public get popup(): IPopup { return this._popup;} private _popup: IPopup;
    public set isLoading(v: boolean) { this._isLoading = v; } public get isLoading(): boolean { return this._isLoading;} private _isLoading: boolean;
    public set groups(v: ObservableArray<MeasuredParameterGroup>) { this._groups = v; } public get groups(): ObservableArray<MeasuredParameterGroup> { return this._groups;} private _groups: ObservableArray<MeasuredParameterGroup>;
        
    save():void{
        this.dataContext.save();
    }

    downloadExcelTemplate():void{
        this.dataContext.downloadExcelTemplate();
    }
}
